import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { useNavigate, type NavigateParams } from './useNavigate';

/**
 * Steps back when the caller knows the previous entry is the page to return to, and navigates to
 * `fallback` otherwise.
 */
export const useGoBackOr = () => {
    const history = useHistory();
    const navigate = useNavigate();

    return useCallback(
        (canGoBack: boolean, fallback: NavigateParams) => {
            if (canGoBack) {
                history.goBack();
                return;
            }

            navigate(fallback);
        },
        [history, navigate],
    );
};
